import {
  faBars,
  faHeart,
  faMapMarkerAlt,
  faPaperPlane,
  faUser,
  faShoppingBasket,
} from '@fortawesome/free-solid-svg-icons';

export const getIcon = (icon, isLoggedIn, badgeContent) => {
  switch (icon) {
    case 'burger':
      return {
        ariaLabel: 'Menu',
        dataQa: 'mobileMenu',
        faIcon: faBars,
        tooltip: 'Menu',
      };

    case 'location':
      return {
        ariaLabel: 'Change location',
        dataQa: 'changeLocation',
        faIcon: faMapMarkerAlt,
        tooltip: 'Location',
      };

    case 'subscribe':
      return {
        ariaLabel: 'Subscribe to our Newsletter',
        dataQa: 'subscribe',
        faIcon: faPaperPlane,
        tooltip: 'Subscribe',
      };

    case 'login':
      return {
        ariaLabel: isLoggedIn ? 'Menu' : 'Login',
        dataQa: 'login',
        faIcon: faUser,
        tooltip: isLoggedIn ? 'Menu' : 'Login',
      };

    case 'basket':
      return {
        ariaLabel: !isNaN(badgeContent)
          ? `${badgeContent} Item in Basket`
          : 'Basket',
        dataQa: 'goToBasket',
        faIcon: faShoppingBasket,
        tooltip: 'Basket',
      };

    case 'wishlist':
      return {
        ariaLabel: 'Wishlist',
        dataQa: 'wishlist',
        faIcon: faHeart,
        tooltip: 'Wishlist',
      };

    default:
      return {
        ariaLabel: '',
        dataQa: '',
        faIcon: faMapMarkerAlt,
        tooltip: '',
      };
  }
};
